import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptor } from 'src/app/4.repository/4.1.common/http.interceptor';
import { ApiEndpoint } from 'src/app/4.repository/4.1.common/api.endpoint';
import { LocalParemeters } from 'src/app/4.repository/4.4.local/local.parameters';
import { RespositoryParameters } from 'src/app/4.repository/repository.parameters';
import { NetworkingUserRegister } from 'src/app/4.repository/4.5.networking/networking.user.register';
import { RepositoryUserRegister } from 'src/app/4.repository/repository.user.register';
import { NetworkingScheduleSetting } from 'src/app/4.repository/4.5.networking/networking.schedule.setting';
import { RepositoryScheduleSetting } from 'src/app/4.repository/repository.schedule.setting';

@NgModule({
    providers: [
        { 
            provide: HTTP_INTERCEPTORS, 
            useClass: HttpInterceptor, 
            multi: true 
        },
        ApiEndpoint,
        LocalParemeters,
        RespositoryParameters,

        NetworkingUserRegister,
        RepositoryUserRegister,

        NetworkingScheduleSetting,
        RepositoryScheduleSetting
    ]
})
export class AppProviderRepository { }